/**
 * @generated SignedSource<<a9e9815167cf406f3c6ef437385f5336>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum LicenseStatus {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  UNLICENSED = "UNLICENSED",
}
export type GetUserAccessQuery_confluence_tenantContext_ConfluenceTenantContext_licensedProducts_LicensedProduct =
  {
    __typename?: "LicensedProduct";
    licenseStatus: LicenseStatus;
    productKey: string;
  };
export type GetUserAccessQuery_confluence_tenantContext_ConfluenceTenantContext =
  {
    __typename?: "ConfluenceTenantContext";
    licensedProducts: Array<GetUserAccessQuery_confluence_tenantContext_ConfluenceTenantContext_licensedProducts_LicensedProduct>;
  };
export type GetUserAccessQuery_Query = {
  __typename?: "Query";
  permitted: boolean;
  confluence_tenantContext: GetUserAccessQuery_confluence_tenantContext_ConfluenceTenantContext | null;
};
export type GetUserAccessQueryVariables = Exact<{
  resourceId: Scalars["String"]["input"];
  permissionId: Scalars["String"]["input"];
}>;
export type GetUserAccessQuery = GetUserAccessQuery_Query;
